import React from 'react';
import { Route, Switch } from 'react-router-dom';
import DashboardPage from '../pages/Dashboard';
import LivePage from '../pages/Live';
import ProfilePage from '../pages/Profile';
import GatewayPage from '../pages/Gateway';
import OrganizationPage from '../pages/Organization';
import EmptyPage from '../components/EmptyPage';
import ServicePage from '../pages/Service';
import CameraPage from '../pages/Camera';
import SystemPage from '../pages/System';
import ReportPage from '../pages/Report';

let routes = (
  <Switch>
    <Route exact path="/">
      <DashboardPage />
    </Route>
    <Route exact path="/live">
      <LivePage />
    </Route>
    <Route exact path="/gateway">
      <GatewayPage />
    </Route>
    <Route exact path="/settings">
      <ProfilePage />
    </Route>
    <Route exact path="/shares">
      <OrganizationPage />
    </Route>
    <Route exact path="/service">
      <ServicePage />
    </Route>
    <Route exact path="/camera">
      <CameraPage />
    </Route>
    <Route exact path="/system">
      <SystemPage />
    </Route>
    <Route exact path="/report">
      <ReportPage />
    </Route>
    <Route>
      <EmptyPage />
    </Route>
  </Switch>
);

export default routes;
